module.exports = __webpack_public_path__ + "img/7.49a3cb30.jpg";